export default __webpack_public_path__ + "static/media/email.e149e460.svg";